module.exports = __webpack_public_path__ + "media/general/components/playButton/images/ic_bars-0d26235981f9048d602c2804ace60fc6.svg";